// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".day[data-v-392df3a6]{color:#131516}.day__title[data-v-392df3a6]{font-size:16px;font-weight:700}.day__subtitle[data-v-392df3a6]{font-size:14px}", ""]);
// Exports
module.exports = exports;
